// src/utils/fetchOrderImages.js
import request from "../utils/request";

export async function fetchOrderImages(oid) {
  try {
    // axios will prepend your baseURL (e.g. /api/v1) automatically
    const { data } = await request.get(`/orders/images/${oid}`);
    return data.signedUrls ?? [];
  } catch (err) {
    // normalize errors
    const status = err.response?.status;
    const statusText = err.response?.statusText ?? err.message;
    throw new Error(`Could not fetch images: ${status} ${statusText}`);
  }
}
